import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["intent"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { FormControl as MuiFormControl } from '@material-ui/core';
const FormControl = /*#__PURE__*/forwardRef(function FormControl(props, ref) {
  const {
      intent
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const error = intent === 'error';
  return /*#__PURE__*/React.createElement(MuiFormControl, Object.assign({}, otherProps, {
    error: error,
    ref: ref
  }));
});
FormControl.propTypes = {
  /**
   * The contents of the form control.
   */
  children: PropTypes.node,
  /**
   * The CSS class name to add to the root node of the component.
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,
  /**
   * If it should have the `error`, `warning` or default styles.
   */
  intent: PropTypes.oneOf([undefined, 'error', 'warning']),
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool
};
export default FormControl;